import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { EntriesService } from './entries.service';
import { TemplatesService } from '../templates/templates.service';
import { catchError, forkJoin, of } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class EntriesResolver {
  public hasPermissions: boolean = false;

  constructor(private entriesService: EntriesService, private templatesService: TemplatesService) {}

  resolve(route: ActivatedRouteSnapshot) {
    return forkJoin({
      templates: this.templatesService.getTemplates(),
      entries: this.entriesService.getEntries()
      
    });
  }
}
